module.exports = __webpack_public_path__ + "img/proactive-transport.b871423b.webp";